// src/notification/firebase.js
import { initializeApp } from "firebase/app";
import { getMessaging, isSupported } from "firebase/messaging";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

let messaging = null;

export async function initFirebase() {
  const supported = await isSupported();
  if (!supported) {
    console.warn("❌ Browser does NOT support FCM");
    return null;
  }

  const app = initializeApp(firebaseConfig);
  messaging = getMessaging(app);
  return messaging;
}

export { messaging };
